import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import { Participante } from './participante';
import { ParticipanteService } from './participante.service';
import { Router } from '@angular/router';
import { Utils } from '../shared/utils';

declare var Materialize: any;
declare var $: any;

@Component({
  selector: 'app-transferir-certificados',
  templateUrl: './transferir-certificados.component.html',
  providers: [ParticipanteService]
})
export class TransferirCertificadosComponent implements OnInit, AfterViewInit {

  @Input() participanteOrigem: Participante;
  @Input() certificado: any; // Certificado específico a ser transferido
  @Output() onTransferenciaConcluida = new EventEmitter<boolean>();

  public participanteDestino: Participante;
  public participantesEncontrados: Participante[] = [];
  public termoBusca: string = '';
  public manterIdentificador: boolean = true;
  public observacao: string = '';
  public busy: Promise<any>;
  public modalId: string = 'modal-transferir-certificado';

  constructor(
    private participanteService: ParticipanteService,
    private router: Router,
    private utils: Utils
  ) { }

  ngOnInit() {
    // Componente inicializado
  }

  buscarParticipante(): void {
    if (this.termoBusca.length < 3) {
      this.participantesEncontrados = [];
      return;
    }

    const params: any = {};
    
    // Tentar identificar se é CPF, email ou nome
    if (this.termoBusca.match(/^\d+$/)) {
      // Apenas números - pode ser CPF
      params.numero_documento = this.termoBusca.replace(/[\.-]/g, '');
      params.tipo_documento = 'cpf';
    } else if (this.termoBusca.includes('@')) {
      // Contém @ - é email
      params.email = this.termoBusca;
    } else {
      // Nome
      params.nome = this.termoBusca;
    }

    this.busy = this.participanteService.pegarTodosParticipantes(params)
      .then(participantes => {
        this.carregar(participantes);
        console.log("participantes encontrados", this.participantesEncontrados);
      })
      .catch(error => {
        this.participantesEncontrados = [];
      });
  }

  carregar(participantes: any): void{
    this.participantesEncontrados = participantes.data;
  }

  selecionarParticipanteDestino(participante: Participante): void {
    this.participanteDestino = participante;
    this.participantesEncontrados = [];
    this.termoBusca = participante.nome;
  }

  limparSelecao(): void {
    this.participanteDestino = null;
    this.termoBusca = '';
    this.participantesEncontrados = [];
  }

  validarFormulario(): boolean {
    if (!this.participanteDestino) {
      this.utils.flashMessage('Selecione um participante destino.', 'warning');
      return false;
    }

    if (this.participanteOrigem && this.participanteOrigem.id === this.participanteDestino.id) {
      this.utils.flashMessage('Participante origem e destino não podem ser o mesmo.', 'warning');
      return false;
    }

    if (!this.certificado && !this.participanteOrigem) {
      this.utils.flashMessage('Nenhum certificado selecionado para transferir.', 'warning');
      return false;
    }

    return true;
  }

  confirmarTransferencia(): void {
    if (!this.validarFormulario()) {
      return;
    }

    const certificadoNome = this.certificado ? this.certificado.documento : 'certificados';
    const mensagem = `Deseja realmente transferir o certificado "${certificadoNome}" de ${this.participanteOrigem.nome} para ${this.participanteDestino.nome}?`;

    if (confirm(mensagem)) {
      this.transferir();
    }
  }

  transferir(): void {
    if (!this.validarFormulario()) {
      return;
    }

    const dados: any = {
      participante_origem_id: this.participanteOrigem.id,
      participante_destino_id: this.participanteDestino.id,
      manter_identificador: this.manterIdentificador ? 1 : 0
    };

    // Se tem certificado específico, usar seu ID do upload_participante
    // O certificado tem source que é o objeto upload_participante completo
    if (this.certificado && this.certificado.source) {
      // source é o objeto UploadParticipante que tem o id
      if (this.certificado.source.id) {
        dados.upload_participantes_ids = [this.certificado.source.id];
      }
    }

    if (this.observacao && this.observacao.trim()) {
      dados.observacao = this.observacao.trim();
    }

    this.busy = this.participanteService.transferirCertificados(dados)
      .then(() => {
        this.fecharModal();
        this.onTransferenciaConcluida.emit(true);
      })
      .catch(error => {
        // Erro já é tratado no service
        console.error('Erro ao transferir certificado:', error);
      });
  }

  fecharModal(): void {
    $('#' + this.modalId).modal('close');
    this.limparSelecao();
    this.observacao = '';
    this.manterIdentificador = true;
  }

  ngAfterViewInit() {
    // Garantir que o modal está inicializado
    setTimeout(() => {
      $('#' + this.modalId).modal({
        dismissible: true,
        onCloseEnd: () => {
          this.limparSelecao();
          this.observacao = '';
          this.manterIdentificador = true;
        }
      });
    }, 200);
  }
}




// WEBPACK FOOTER //
// ./src/app/participantes/transferir-certificados.component.ts